import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    client_name:
      sessionStorage.getItem("client_name") ||
      localStorage.getItem("client_name") ||
      null,
    context_key:
      sessionStorage.getItem("context_key") ||
      localStorage.getItem("context_key") ||
      null,
    appInfo: null,
    serverParams: null,
    defaultCwsSettings: {
      CLIENT_MOTTO: null,
      CLIENT_LOGO: null,
    },
    appLanguage: localStorage.getItem("language") || "fr",
    countries: [],
  };
};

export default {
  state: getDefaultState(),
  getters: {
    getAppInfo: (state) => state.appInfo,
    getDefaultCwsSettings: (state) => state.defaultCwsSettings,
    getServerParams: (state) => state.serverParams,
    getAppLanguage: (state) => state.appLanguage,
    getClientName: (state) => state.client_name,
    getContextKey: (state) => state.context_key,
    getCountries: (state) => state.countries,
    getCwsLogo: (state) =>
      state?.serverParams?.logo || require("@/assets/images/logo_auth.png"),
    getCwsMotto: (state) => state?.serverParams?.motto || "Atu Rtu",
  },
  mutations: {
    APP_INFO_REQUEST(state, value) {
      state.appInfo = value;
    },
    APP_SERVER_PARAMS(state, value) {
      state.serverParams = value;
    },
    DEFAULT_APP_LOGO_MOTTO(state, val) {
      state.defaultCwsSettings = { ...val };
    },
    MUTATE_APP_LANGUAGE(state, val) {
      state.appLanguage = val;
    },
    MUTATE_APP_COUNTRIES: (state, data) => {
      state.countries = data;
    },
    MUTATE_SELECTED_CWS: (state, data) => {
      sessionStorage.setItem("client_name", data);
      localStorage.setItem("client_name", data);
      state.client_name = data;
    },
    MUTATE_SELECTED_ATU: (state, data) => {
      sessionStorage.setItem("context_key", data);
      localStorage.setItem("context_key", data);
      state.context_key = data;
    },
  },
  actions: {
    async APP_INFO_REQUEST(ctx) {
      try {
        const resp = await axios.get("/app-version");
        ctx.commit("APP_INFO_REQUEST", resp.data);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async APP_SERVER_PARAMS(ctx) {
      const client_name = ctx.getters.getClientName;
      try {
        const resp = await axios.get(`/${client_name}/params`);
        ctx.commit("APP_SERVER_PARAMS", resp.data);
      } catch (e) {
        console.log(e);
        if (e?.response?.status === 400) {
          router.push({
            name: "PageError",
            params: {
              message: "Not Found Cleanweb",
            },
          });
        }
        throw e;
      }
    },
    async DEFAULT_APP_LOGO_MOTTO(ctx) {
      try {
        const resp = await axios.get(`/prop`);
        const data = {
          CLIENT_LOGO: resp.data[0].value,
          CLIENT_MOTTO: resp.data[1].value,
        };
        ctx.commit("DEFAULT_APP_LOGO_MOTTO", data);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
    async APP_COUNTRIES(ctx) {
      try {
        const resp = await axios.get("/params/countries");
        ctx.commit("MUTATE_APP_COUNTRIES", resp.data.countries);
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
};
